import { segmentTrackAction } from '../../../../../../../middlewares/segment';
import { Dispatch, ThunkAction } from '../../../../../../../types/actions';

export const onTabBackupsActive = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch
    ) => {
        // console.log('segment onTabBackupsActive');
    };
    return action;
};
